import React from 'react';

import { ICONS } from 'shared/presentation/constants';

import * as S from './styles';

const Icon = ICONS.CHECK;

interface IStepsProgressBarProps {
  steps: Array<{
    name: string;
    status: 'ACTIVE' | 'INACTIVE' | 'COMPLETE';
    title: string;
  }>;
  height?: number;
}

const StepsProgressBar: React.FC<IStepsProgressBarProps> = ({
  steps,
  height = 4,
}) => (
  <S.Container>
    {steps.map((step, index) => (
      <S.Step
        key={step.name}
        status={step.status}
        isLast={index === steps.length - 1}
        height={height}
      >
        <section>
          <div>{step.status === 'COMPLETE' ? <Icon /> : index + 1}</div>

          <span>{step.title}</span>
        </section>

        <hr />
      </S.Step>
    ))}
  </S.Container>
);

export default StepsProgressBar;
